/**
 * This module is intended to be consumed by any other module
 * you may create.  Please declare and export anything that is shared
 * except for Services - those should be in the core app.module
 *
 * the services are done this way so all modules use the same injected
 * instance.  If you need your module to instance a new variant, feel free
 * to overwrite this (but do so with caution)
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import {
  MatSnackBarModule,
  MAT_SNACK_BAR_DEFAULT_OPTIONS
} from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  NgxUiLoaderConfig,
  NgxUiLoaderModule,
  PB_DIRECTION,
  POSITION,
  SPINNER
} from 'ngx-ui-loader';
import { BarcodeComponent } from './components/barcode/barcode.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DebugComponent } from './components/debug/debug.component';
import { ManualScanDialogComponent } from './components/manual_scan/manual-scan.component';
import { QuantityScanDialogComponent } from './components/quantity_scan/quantity-scan.component';
import { ReorderDialogComponent } from './components/reorder-dialog/confirm-dialog.component';
import { SafePipe } from './pipes/safe.pipe';
import { SelectFilterPipe } from './pipes/search-filter.pipe';
import { TranslatePipe } from './pipes/translate.pipe';

const NGX_UI_LOADER_CONFIG_1: NgxUiLoaderConfig = {
  fgsColor: '#ff4081',
  bgsPosition: POSITION.centerCenter,
  bgsSize: 40,
  //	bgsType: SPINNER.rectangleBounceParty, // background spinner type
  fgsType: SPINNER.rotatingPlane, // foreground spinner type
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 5, // progress bar thickness
  pbColor: '#ff4081'
};

@NgModule({
  declarations: [
    // components, directives and pipes
    DebugComponent,
    ConfirmDialogComponent,
    ReorderDialogComponent,
    ManualScanDialogComponent,
    QuantityScanDialogComponent,
    TranslatePipe,
    SafePipe,
    // NewitemDialogComponent,
    // ScannerConfirmDialogComponent,
    BarcodeComponent,
    SelectFilterPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    // material modules USED explicitly by the shared/components and what not
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatAutocompleteModule
  ],
  providers: [
    TranslatePipe,
    SafePipe,

    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      }
    }
  ],
  exports: [
    // the common shit
    CommonModule,
    MatRadioModule,
    // forms
    FormsModule,
    ReactiveFormsModule,

    // material - export all of the common.  tree shaking "should" get rid of these if unused

    MatCheckboxModule,
    // export our shared components & pipes
    DebugComponent,
    ConfirmDialogComponent,
    ReorderDialogComponent,
    ManualScanDialogComponent,
    // NewitemDialogComponent,
    // ScannerConfirmDialogComponent,
    QuantityScanDialogComponent,
    TranslatePipe,
    SafePipe,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatDialogModule,
    MatMenuModule,
    MatDividerModule,
    MatSnackBarModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatListModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatSelectModule,
    NgxUiLoaderModule,
    // export our shared components & pipes
    DebugComponent,
    ConfirmDialogComponent,
    BarcodeComponent,
    TranslatePipe,
    SafePipe,
    SelectFilterPipe
  ]
})
export class SharedModule {}
